import { ACTION_TYPE } from "./ActionTypes";

export const changePage = page => dispatch => {
  dispatch({ type: ACTION_TYPE.LOGS.CHANGE_PAGE, payload: page });  
};

export const changeRowsPerPage = rowsPerPage => dispatch => {
  dispatch({ type: ACTION_TYPE.LOGS.CHANGE_ROWS_PER_PAGE, payload: rowsPerPage });
};


// WEBPACK FOOTER //
// ./src/actions/LogsActions.js